import React from 'react'

class Intro extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="intro intro--shortenMore">
        <div className="container">
          <div className="intro__content">
            <h1>Frequently Asked Questions</h1>
            <p>
              Whether you’re a principal, parent, player, coach or teacher, we want to answer your question.
              Can’t find your answer? Get in touch at <a href="mailto:hello@playvs.com">hello@playvs.com</a>.
            </p>
          </div>
        </div>
        {/*<div className="intro__mask intro__mask--fadeToRight"></div>*/}
      </div>
    )
  }
}

export default Intro



// WEBPACK FOOTER //
// ./src/common/ui/components/IntroFAQ.js